import { render, staticRenderFns } from "./SmartFamilyDoc.vue?vue&type=template&id=5e91e8d4&"
import script from "./SmartFamilyDoc.vue?vue&type=script&lang=js&"
export * from "./SmartFamilyDoc.vue?vue&type=script&lang=js&"
import style0 from "./SmartFamilyDoc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports